import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setNotification } from "features/Notification/notificationSlice";
import API from "services/axios";
import authHeader from "services/auth-header";
import Spinner from "components/Spinner";
import { Accordion, Button } from "react-bootstrap";

export default function ShipmentLabel() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [labelImage, setLabelImage] = useState("");

  // Form states
  const [shipmentForm, setShipmentForm] = useState({
    // Shipment details
    description: "Ship WS test",

    // Shipper Information
    shipperName: "ShipperName",
    shipperAttentionName: "ShipperZs Attn Name",
    shipperTaxId: "123456",
    shipperPhone: "1115554758",
    shipperPhoneExt: "",
    shipperNumber: "89R881",
    shipperFax: "8002222222",
    shipperAddressLine: "2311 York Rd",
    shipperCity: "Alpharetta",
    shipperStateCode: "MD",
    shipperPostalCode: "21093",
    shipperCountryCode: "pk",

    // Ship To Information
    recipientName: "Happy Dog Pet Supply",
    recipientAttentionName: "1160b_74",
    recipientPhone: "9225377171",
    recipientAddressLine: "123 Main St",
    recipientCity: "Timonium",
    recipientStateCode: "ON",
    recipientPostalCode: "K4A 9Z9",
    recipientCountryCode: "CA",
    isResidential: "",

    shipFromAttentionName: "1160b_74",
    shipFromPhone: "1234567890",
    shipFromFax: "1234567890",
    shipFromAddressLine: "2311 York Rd",
    shipFromCity: "Alpharetta",
    shipFromStateCode: "GA",
    shipFromPostalCode: "30005",
    shipFromCountryCode: "pk",

    // Payment Information
    paymentType: "01", // 01 = Bill Shipper
    accountNumber: "89R881",

    // Service Information
    serviceCode: "65", // 65 = Express
    serviceDescription: "Express",

    // Package Information - Now stored in separate state

    // Label Format
    labelFormatCode: "GIF",
    labelFormatDescription: "GIF",
    userAgent: "Mozilla/4.5",
  });

  // State for packages - now managed as an array for multiple packages
  const [packages, setPackages] = useState([
    {
      id: 1, // for UI tracking
      packageDescription: "Package 1",
      packagingCode: "02",
      packagingDescription: "Nails",
      dimensionsUnitCode: "CM",
      dimensionsUnitDescription: "Centimeters",
      length: "50",
      width: "50",
      height: "60",
      weightUnitCode: "KGS",
      weightUnitDescription: "Kilograms",
      weight: "24",
    },
  ]);

  // Current package being edited
  const [currentPackage, setCurrentPackage] = useState({
    packageDescription: "",
    packagingCode: "02",
    packagingDescription: "",
    dimensionsUnitCode: "CM",
    dimensionsUnitDescription: "Centimeters",
    length: "",
    width: "",
    height: "",
    weightUnitCode: "KGS",
    weightUnitDescription: "Kilograms",
    weight: "",
  });

  // Toggle for showing package form
  const [showPackageForm, setShowPackageForm] = useState(false);
  const [isEditingPackage, setIsEditingPackage] = useState(false);
  const [editingPackageId, setEditingPackageId] = useState(null);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setShipmentForm({
      ...shipmentForm,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handlePackageInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentPackage({
      ...currentPackage,
      [name]: value,
    });
  };

  const addNewPackage = () => {
    setCurrentPackage({
      packageDescription: "",
      packagingCode: "02",
      packagingDescription: "",
      dimensionsUnitCode: "CM",
      dimensionsUnitDescription: "Centimeters",
      length: "",
      width: "",
      height: "",
      weightUnitCode: "KGS",
      weightUnitDescription: "Kilograms",
      weight: "",
    });
    setIsEditingPackage(false);
    setShowPackageForm(true);
  };

  const savePackage = () => {
    if (isEditingPackage) {
      // Update existing package
      setPackages(
        packages.map((pkg) =>
          pkg.id === editingPackageId
            ? { ...currentPackage, id: editingPackageId }
            : pkg
        )
      );
    } else {
      // Add new package
      const newPackageId =
        packages.length > 0
          ? Math.max(...packages.map((pkg) => pkg.id)) + 1
          : 1;
      setPackages([...packages, { ...currentPackage, id: newPackageId }]);
    }
    setShowPackageForm(false);
  };

  const editPackage = (pkg) => {
    setCurrentPackage({ ...pkg });
    setEditingPackageId(pkg.id);
    setIsEditingPackage(true);
    setShowPackageForm(true);
  };

  const deletePackage = (id) => {
    setPackages(packages.filter((pkg) => pkg.id !== id));
  };

  const createShipmentRequest = () => {
    // Map packages to the format expected by the API
    const packageList = packages.map((pkg) => ({
      Description: pkg.packageDescription,
      Packaging: {
        Code: pkg.packagingCode,
        Description: pkg.packagingDescription,
      },
      Dimensions: {
        UnitOfMeasurement: {
          Code: pkg.dimensionsUnitCode,
          Description: pkg.dimensionsUnitDescription,
        },
        Length: pkg.length,
        Width: pkg.width,
        Height: pkg.height,
      },
      PackageWeight: {
        UnitOfMeasurement: {
          Code: pkg.weightUnitCode,
          Description: pkg.weightUnitDescription,
        },
        Weight: pkg.weight,
      },
    }));

    return {
      ShipmentRequest: {
        Request: {
          SubVersion: "1801",
          RequestOption: "nonvalidate",
          TransactionReference: { CustomerContext: "" },
        },
        Shipment: {
          Description: shipmentForm.description,
          Shipper: {
            Name: shipmentForm.shipperName,
            AttentionName: shipmentForm.shipperAttentionName,
            TaxIdentificationNumber: shipmentForm.shipperTaxId,
            Phone: {
              Number: shipmentForm.shipperPhone,
              Extension: shipmentForm.shipperPhoneExt,
            },
            ShipperNumber: shipmentForm.shipperNumber,
            FaxNumber: shipmentForm.shipperFax,
            Address: {
              AddressLine: [shipmentForm.shipperAddressLine],
              City: shipmentForm.shipperCity,
              StateProvinceCode: shipmentForm.shipperStateCode,
              PostalCode: shipmentForm.shipperPostalCode,
              CountryCode: shipmentForm.shipperCountryCode,
            },
          },
          ShipTo: {
            Name: shipmentForm.recipientName,
            AttentionName: shipmentForm.recipientAttentionName,
            Phone: { Number: shipmentForm.recipientPhone },
            Address: {
              AddressLine: [shipmentForm.recipientAddressLine],
              City: shipmentForm.recipientCity,
              StateProvinceCode: shipmentForm.recipientStateCode,
              PostalCode: shipmentForm.recipientPostalCode,
              CountryCode: shipmentForm.recipientCountryCode,
            },
            Residential: shipmentForm.isResidential ? " " : "",
          },
          ShipFrom: {
            Name: shipmentForm.shipFromName,
            AttentionName: shipmentForm.shipFromAttentionName,
            Phone: { Number: shipmentForm.shipFromPhone },
            FaxNumber: shipmentForm.shipFromFax,
            Address: {
              AddressLine: [shipmentForm.shipFromAddressLine],
              City: shipmentForm.shipFromCity,
              StateProvinceCode: shipmentForm.shipFromStateCode,
              PostalCode: shipmentForm.shipFromPostalCode,
              CountryCode: shipmentForm.shipFromCountryCode,
            },
          },
          PaymentInformation: {
            ShipmentCharge: {
              Type: shipmentForm.paymentType,
              BillShipper: { AccountNumber: shipmentForm.accountNumber },
            },
          },
          Service: {
            Code: shipmentForm.serviceCode,
            Description: shipmentForm.serviceDescription,
          },
          Package: packageList, // Using the array of packages
        },
        LabelSpecification: {
          LabelImageFormat: {
            Code: shipmentForm.labelFormatCode,
            Description: shipmentForm.labelFormatDescription,
          },
          HTTPUserAgent: shipmentForm.userAgent,
        },
      },
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate that at least one package exists
    if (packages.length === 0) {
      dispatch(
        setNotification({
          message: "At least one package is required",
          type: "error",
        })
      );
      return;
    }

    setLoading(true);

    try {
      const { data } = await API.post(
        "/shipment/create-label",
        createShipmentRequest(),
        {
          headers: authHeader(),
        }
      );

      if (data?.success) {
        dispatch(
          setNotification({
            message: "Shipment label created successfully!",
            type: "success",
          })
        );

        // If there's a label image in the response
        if (
          data?.data?.ShipmentResponse?.ShipmentResults?.PackageResults
            ?.ShippingLabel?.GraphicImage
        ) {
          setLabelImage(
            data.data.ShipmentResponse.ShipmentResults.PackageResults
              .ShippingLabel.GraphicImage
          );
          setShowPreview(true);
        }
      } else {
        dispatch(
          setNotification({
            message: data?.message || "Failed to create shipment label",
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message || "An error occurred",
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginLeft: 260 }} className="px-3 py-3">
      {loading && <Spinner />}

      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="mb-4">Create UPS Shipment Label</h2>

            <form onSubmit={handleSubmit}>
              {/* Shipment Details */}
              <div className="card mb-4">
                <div className="card-header">
                  <h4>Shipment Details</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="description" className="form-label">
                          Shipment Description
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="description"
                          name="description"
                          value={shipmentForm.description}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="serviceCode" className="form-label">
                          Service Type
                        </label>
                        <select
                          className="form-select"
                          id="serviceCode"
                          name="serviceCode"
                          value={shipmentForm.serviceCode}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="65">UPS Express</option>
                          <option value="01">UPS Next Day Air</option>
                          <option value="02">UPS 2nd Day Air</option>
                          <option value="03">UPS Ground</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Shipper Information */}
              <div className="card mb-4">
                <div className="card-header">
                  <h4>Shipper Information</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="shipperName" className="form-label">
                          Shipper Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperName"
                          name="shipperName"
                          value={shipmentForm.shipperName}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          htmlFor="shipperAttentionName"
                          className="form-label"
                        >
                          Attention Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperAttentionName"
                          name="shipperAttentionName"
                          value={shipmentForm.shipperAttentionName}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="shipperTaxId" className="form-label">
                          Tax ID
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperTaxId"
                          name="shipperTaxId"
                          value={shipmentForm.shipperTaxId}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="shipperPhone" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperPhone"
                          name="shipperPhone"
                          value={shipmentForm.shipperPhone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="shipperNumber" className="form-label">
                          UPS Account Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperNumber"
                          name="shipperNumber"
                          value={shipmentForm.shipperNumber}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="mb-3">
                        <label
                          htmlFor="shipperAddressLine"
                          className="form-label"
                        >
                          Address Line
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperAddressLine"
                          name="shipperAddressLine"
                          value={shipmentForm.shipperAddressLine}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="shipperCity" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperCity"
                          name="shipperCity"
                          value={shipmentForm.shipperCity}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="shipperStateCode"
                          className="form-label"
                        >
                          State/Province
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperStateCode"
                          name="shipperStateCode"
                          value={shipmentForm.shipperStateCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="shipperPostalCode"
                          className="form-label"
                        >
                          Postal Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperPostalCode"
                          name="shipperPostalCode"
                          value={shipmentForm.shipperPostalCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="shipperCountryCode"
                          className="form-label"
                        >
                          Country Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipperCountryCode"
                          name="shipperCountryCode"
                          value={shipmentForm.shipperCountryCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Ship To Information */}
              <div className="card mb-4">
                <div className="card-header">
                  <h4>Ship To Information</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="recipientName" className="form-label">
                          Recipient Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="recipientName"
                          name="recipientName"
                          value={shipmentForm.recipientName}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          htmlFor="recipientAttentionName"
                          className="form-label"
                        >
                          Attention Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="recipientAttentionName"
                          name="recipientAttentionName"
                          value={shipmentForm.recipientAttentionName}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="recipientPhone" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="recipientPhone"
                          name="recipientPhone"
                          value={shipmentForm.recipientPhone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3 form-check mt-4">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="isResidential"
                          name="isResidential"
                          checked={shipmentForm.isResidential}
                          onChange={handleInputChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="isResidential"
                        >
                          Residential Address
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="mb-3">
                        <label
                          htmlFor="recipientAddressLine"
                          className="form-label"
                        >
                          Address Line
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="recipientAddressLine"
                          name="recipientAddressLine"
                          value={shipmentForm.recipientAddressLine}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="recipientCity" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="recipientCity"
                          name="recipientCity"
                          value={shipmentForm.recipientCity}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="recipientStateCode"
                          className="form-label"
                        >
                          State/Province
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="recipientStateCode"
                          name="recipientStateCode"
                          value={shipmentForm.recipientStateCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="recipientPostalCode"
                          className="form-label"
                        >
                          Postal Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="recipientPostalCode"
                          name="recipientPostalCode"
                          value={shipmentForm.recipientPostalCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="recipientCountryCode"
                          className="form-label"
                        >
                          Country Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="recipientCountryCode"
                          name="recipientCountryCode"
                          value={shipmentForm.recipientCountryCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Ship From Information */}
              <div className="card mb-4">
                <div className="card-header">
                  <h4>Ship From Information</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="shipFromName" className="form-label">
                          From Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipFromName"
                          name="shipFromName"
                          value={shipmentForm.shipFromName}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          htmlFor="shipFromAttentionName"
                          className="form-label"
                        >
                          Attention Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipFromAttentionName"
                          name="shipFromAttentionName"
                          value={shipmentForm.shipFromAttentionName}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="shipFromPhone" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipFromPhone"
                          name="shipFromPhone"
                          value={shipmentForm.shipFromPhone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="shipFromFax" className="form-label">
                          Fax Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipFromFax"
                          name="shipFromFax"
                          value={shipmentForm.shipFromFax}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="mb-3">
                        <label
                          htmlFor="shipFromAddressLine"
                          className="form-label"
                        >
                          Address Line
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipFromAddressLine"
                          name="shipFromAddressLine"
                          value={shipmentForm.shipFromAddressLine}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="shipFromCity" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipFromCity"
                          name="shipFromCity"
                          value={shipmentForm.shipFromCity}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="shipFromStateCode"
                          className="form-label"
                        >
                          State/Province
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipFromStateCode"
                          name="shipFromStateCode"
                          value={shipmentForm.shipFromStateCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="shipFromPostalCode"
                          className="form-label"
                        >
                          Postal Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipFromPostalCode"
                          name="shipFromPostalCode"
                          value={shipmentForm.shipFromPostalCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label
                          htmlFor="shipFromCountryCode"
                          className="form-label"
                        >
                          Country Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="shipFromCountryCode"
                          name="shipFromCountryCode"
                          value={shipmentForm.shipFromCountryCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="sameAsShipper"
                          name="sameAsShipper"
                          onChange={(e) => {
                            if (e.target.checked) {
                              // Copy shipper address to ship from address
                              setShipmentForm({
                                ...shipmentForm,
                                shipFromName: shipmentForm.shipperName,
                                shipFromAttentionName:
                                  shipmentForm.shipperAttentionName,
                                shipFromPhone: shipmentForm.shipperPhone,
                                shipFromFax: shipmentForm.shipperFax,
                                shipFromAddressLine:
                                  shipmentForm.shipperAddressLine,
                                shipFromCity: shipmentForm.shipperCity,
                                shipFromStateCode:
                                  shipmentForm.shipperStateCode,
                                shipFromPostalCode:
                                  shipmentForm.shipperPostalCode,
                                shipFromCountryCode:
                                  shipmentForm.shipperCountryCode,
                              });
                            }
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="sameAsShipper"
                        >
                          Same as Shipper Address
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Package Information - Updated with Accordion CRUD */}
              <div className="card mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4>Package Information</h4>
                  <Button variant="primary" size="sm" onClick={addNewPackage}>
                    Add New Package
                  </Button>
                </div>
                <div className="card-body">
                  {showPackageForm && (
                    <div className="package-form mb-4 border p-3 rounded bg-light">
                      <h5>
                        {isEditingPackage ? "Edit Package" : "Add New Package"}
                      </h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label
                              htmlFor="packageDescription"
                              className="form-label"
                            >
                              Package Description
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="packageDescription"
                              name="packageDescription"
                              value={currentPackage.packageDescription}
                              onChange={handlePackageInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label
                              htmlFor="packagingCode"
                              className="form-label"
                            >
                              Packaging Type
                            </label>
                            <select
                              className="form-select"
                              id="packagingCode"
                              name="packagingCode"
                              value={currentPackage.packagingCode}
                              onChange={handlePackageInputChange}
                              required
                            >
                              <option value="01">UPS Letter</option>
                              <option value="02">Your Packaging</option>
                              <option value="03">UPS Tube</option>
                              <option value="04">UPS PAK</option>
                              <option value="21">UPS Express Box</option>
                              <option value="24">UPS 25KG Box</option>
                              <option value="25">UPS 10KG Box</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-3">
                          <div className="mb-3">
                            <label htmlFor="length" className="form-label">
                              Length
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="length"
                              name="length"
                              value={currentPackage.length}
                              onChange={handlePackageInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="mb-3">
                            <label htmlFor="width" className="form-label">
                              Width
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="width"
                              name="width"
                              value={currentPackage.width}
                              onChange={handlePackageInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="mb-3">
                            <label htmlFor="height" className="form-label">
                              Height
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="height"
                              name="height"
                              value={currentPackage.height}
                              onChange={handlePackageInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="mb-3">
                            <label
                              htmlFor="dimensionsUnitCode"
                              className="form-label"
                            >
                              Units
                            </label>
                            <select
                              className="form-select"
                              id="dimensionsUnitCode"
                              name="dimensionsUnitCode"
                              value={currentPackage.dimensionsUnitCode}
                              onChange={(e) => {
                                setCurrentPackage({
                                  ...currentPackage,
                                  dimensionsUnitCode: e.target.value,
                                  dimensionsUnitDescription:
                                    e.target.value === "CM"
                                      ? "Centimeters"
                                      : "Inches",
                                });
                              }}
                              required
                            >
                              <option value="CM">Centimeters</option>
                              <option value="IN">Inches</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label htmlFor="weight" className="form-label">
                              Weight
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="weight"
                              name="weight"
                              value={currentPackage.weight}
                              onChange={handlePackageInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label
                              htmlFor="weightUnitCode"
                              className="form-label"
                            >
                              Weight Units
                            </label>
                            <select
                              className="form-select"
                              id="weightUnitCode"
                              name="weightUnitCode"
                              value={currentPackage.weightUnitCode}
                              onChange={(e) => {
                                setCurrentPackage({
                                  ...currentPackage,
                                  weightUnitCode: e.target.value,
                                  weightUnitDescription:
                                    e.target.value === "KGS"
                                      ? "Kilograms"
                                      : "Pounds",
                                });
                              }}
                              required
                            >
                              <option value="KGS">Kilograms</option>
                              <option value="LBS">Pounds</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={() => setShowPackageForm(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={savePackage}
                        >
                          {isEditingPackage ? "Update Package" : "Save Package"}
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Package List Accordion */}
                  {packages.length === 0 ? (
                    <div className="alert alert-warning">
                      No packages added. Please add at least one package for
                      your shipment.
                    </div>
                  ) : (
                    <Accordion
                      defaultActiveKey="0"
                      className="packages-accordion"
                    >
                      {packages.map((pkg, index) => (
                        <Accordion.Item
                          eventKey={index.toString()}
                          key={pkg.id}
                        >
                          <Accordion.Header>
                            <div className="d-flex w-100 justify-content-between align-items-center">
                              <span>
                                <strong>Package {index + 1}:</strong>{" "}
                                {pkg.packageDescription || "No description"}
                              </span>
                              <span className="badge bg-primary me-2">
                                {pkg.weight} {pkg.weightUnitCode}
                              </span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="row">
                              <div className="col-md-6">
                                <p>
                                  <strong>Packaging:</strong>{" "}
                                  {pkg.packagingDescription ||
                                    pkg.packagingCode}
                                </p>
                                <p>
                                  <strong>Dimensions:</strong> {pkg.length} x{" "}
                                  {pkg.width} x {pkg.height}{" "}
                                  {pkg.dimensionsUnitCode}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <strong>Weight:</strong> {pkg.weight}{" "}
                                  {pkg.weightUnitCode}
                                </p>
                              </div>
                            </div>
                            <div className="d-flex justify-content-end">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                className="me-2"
                                onClick={() => editPackage(pkg)}
                              >
                                Edit
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => deletePackage(pkg.id)}
                              >
                                Delete
                              </Button>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              <div className="row">
                <div className="col-12 d-grid">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    disabled={loading || packages.length === 0}
                  >
                    {loading ? "Creating Label..." : "Create Shipment Label"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Preview Modal for Shipment Label */}
        {showPreview && labelImage && (
          <div className="row mt-4">
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4>Shipment Label</h4>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowPreview(false)}
                  >
                    Close
                  </button>
                </div>
                <div className="card-body text-center">
                  <img
                    src={`data:image/gif;base64,${labelImage}`}
                    alt="UPS Shipping Label"
                    className="img-fluid"
                    style={{ maxHeight: "500px" }}
                  />
                  <div className="mt-3">
                    <a
                      href={`data:image/gif;base64,${labelImage}`}
                      download="ups-shipping-label.gif"
                      className="btn btn-success"
                    >
                      Download Label
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
